import { t } from '@lingui/macro';
import clsx from 'clsx';

import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import usePanelDataService from '../../../services/PanelDataService';
import PerformanceChart from '../../charts/performance-chart/PerformanceChart';
import { BuiltInTooltip } from '../../charts/tooltip/types';
import { FORMATTER_TYPES } from '../../../utilities/FormattingUtilities';
import { timeRangeFilterId } from '../../filters';

const title = t`nPoints`;

const NPOINT_OFFLINE_NUM_METRIC = 'ngpNpointOfflineNum';
const NPOINT_RUNNING_NUM_METRIC = 'ngpNpointRunningNum';
const NPOINT_DISABLED_NUM_METRIC = 'ngpNpointDisabledNum';

const dataSource = {
    url: '/query/chart',
    params: {
        type: 'ngphealth',
        metrics: [NPOINT_OFFLINE_NUM_METRIC, NPOINT_RUNNING_NUM_METRIC, NPOINT_DISABLED_NUM_METRIC],
    },
};

const chartConfig = {
    yAxis: [
        {
            title: {
                text: t`nPoint counts`,
            },
            min: 0,
            allowDecimals: false,
        },
    ],
    tooltip: BuiltInTooltip,
    showGranularity: true,
    chartTrends: [
        {
            formatter: FORMATTER_TYPES.INTEGER,
            units: '',
            chartType: 'spline',
            label: 'Running',
            key: NPOINT_RUNNING_NUM_METRIC,
            color: '#7cb5ec',
        },
        {
            formatter: FORMATTER_TYPES.INTEGER,
            units: '',
            chartType: 'spline',
            label: 'Disabled',
            key: NPOINT_DISABLED_NUM_METRIC,
            color: 'orange',
        },
        {
            formatter: FORMATTER_TYPES.INTEGER,
            units: '',
            chartType: 'spline',
            label: 'Offline',
            key: NPOINT_OFFLINE_NUM_METRIC,
            color: 'red',
        },
    ],
};
function NPointNumPanel() {
    const data = usePanelDataService(dataSource);
    const chartData = data?.data?.[0];

    if (!data) return null;

    return (
        <div className={clsx('flex-container')}>
            <PerformanceChart chartDef={chartConfig} data={chartData} xAxis={{ minTickInterval: 5 * 60 * 1000 }} />
        </div>
    );
}

NPointNumPanel.propTypes = panelPropTypes;

NPointNumPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 175,
    minContentHeight: 175,
};

export default Panel({
    typeAlias: 'nGPnPointNumTrend',
    filters: {
        required: [timeRangeFilterId],
        optional: [],
    },
})(NPointNumPanel);
